module.exports = __webpack_public_path__ + "static/img/cgal6.7e9c621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal6.png
// module id = RC4t
// module chunks = 1